import { createContext, useContext, useState } from 'react';
import {
  AppContainerContextValue,
  ContentMeta,
  SIDEBAR_MODE,
  SiestaMode,
  SidebarMode,
} from './types';

const AppContainerContext = createContext<AppContainerContextValue | undefined>(undefined);

type Props = {
  children: React.ReactNode;
  skipDefaultSidebar?: boolean;
};

export function AppContainerProvider({ children, skipDefaultSidebar = false }: Props) {
  const [sidebarContent, setSidebarContent] = useState<React.ReactNode | null>(null);
  const [contentMeta, setContentMeta] = useState<ContentMeta | null>(null);
  const [mode, setMode] = useState<SidebarMode>('standard');
  const [siestaMode, setSiestaMode] = useState<SiestaMode>('action');
  const [siestaBusyGlowTop, setSiestaBusyGlowTop] = useState<number | null>(null);

  const toggleMode = () => {
    setMode(prev =>
      prev === SIDEBAR_MODE.standard ? SIDEBAR_MODE.expanded : SIDEBAR_MODE.standard,
    );
  };

  return (
    <AppContainerContext.Provider
      value={{
        skipDefaultSidebar,
        sidebarContent,
        setSidebarContent,
        contentMeta,
        setContentMeta,
        mode,
        setMode,
        toggleMode,
        siestaMode,
        setSiestaMode,
        siestaBusyGlowTop,
        setSiestaBusyGlowTop,
      }}
    >
      {children}
    </AppContainerContext.Provider>
  );
}

export function useAppContainerContext() {
  const context = useContext(AppContainerContext);
  if (context === undefined) {
    throw new Error('useAppContainerContext must be used within AppContainerProvider');
  }
  return context;
}
